import type { EventObject } from 'xstate';

export type ReplayableEvent<Event> = Event & { replay?: true };

export const createReplay =
  <Event extends EventObject>() =>
  (event: Event): ReplayableEvent<Event> => ({ ...event, replay: true });
